import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, useMediaQuery, Paper, Grid, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import ScmBottomButtonsforWorkOrder from "./ScmBottomButtonsforWorkOrder";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { useDispatch, useSelector } from "react-redux";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { format } from "date-fns";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { getAuthToken, getuserId } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { checkFormSubmitForVendor } from "../../redux/actions/vendor/webFormActions";
import ScmRepositry from "../../api/repositories/scmRepository";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";
import { processingPercentageValue, statusList } from "../../utility/message";
import dayjs from "dayjs";


const ScmSummaryAuthorization = ({ page, buttonAttributes, setAuthorizeTick }) => {

    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "SCMT001");

    //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );

    const dispatch = useDispatch();
    const location = useLocation();
    const token = getAuthToken("id_token");
    const authorizeBy = localStorage.getItem("UserName");
    const userID = getuserId("UserId")
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const basicDetails = useSelector((state) => state.scmBasicDetails);
    console.log(basicDetails, "basicDetails");
    
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const viewmode = location.state?.viewmode;
    const checkFormSubmitted = basicDetails?.formSubmitStatus;
    const repairTrackerRows = basicDetails?.assessments.repairTracker || [];
    const setOutsourceDetails = basicDetails?.vendorField;
    const getVendorCode = basicDetails?.assessments?.vendor?.vendorcode || "";
    const getVendorName = basicDetails?.assessments?.vendor?.label || "";
    const completionInfo = basicDetails?.completionInfo || {};
    const costInfo = basicDetails?.completionInfo?.costInfo || {};
    const partReplacementRows = basicDetails?.partReplacementRows || [];
    const totalSparePartCost = partReplacementRows?.reduce((acc, part) => acc + parseFloat(part?.partCost || 0), 0) || 0;
    const workorderDateTime = basicDetails?.workorderDateandTime || "";

    const [gridAPI, setGridApi] = useState({});
    const [openAlertDialog, setOpenAlertDialog] = useState();
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [enableSave, setEnableSave] = useState(false);
    const [beforeImageURL, setBeforeImageURL] = useState([]);
    const [afterImageURL, setAfterImageURL] = useState([]);
    const [popupImage, setPopupImage] = useState(null);

    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7,
        "Completed-Outsource":9,
        "In Progress-Outsource":10
    };

    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null;

let getFirstIndexofStartDateTime;
    let getLastIndexofEndDateTime;
 
    if (repairTrackerRows.length === 1) {
      getFirstIndexofStartDateTime = repairTrackerRows[0]?.startDateandTime || "";
      getLastIndexofEndDateTime = repairTrackerRows[0]?.endDateandTime || "";
    } else if (repairTrackerRows.length > 1) {
      getFirstIndexofStartDateTime = repairTrackerRows.reduce((earliest, current) => {
        return new Date(earliest.startDateandTime) < new Date(current.startDateandTime) ? earliest : current;
      }).startDateandTime || "";
      // Find the row with the greatest endDateandTime
      getLastIndexofEndDateTime = repairTrackerRows.reduce((latest, current) => {
        return new Date(latest.endDateandTime) > new Date(current.endDateandTime) ? latest : current;
      }).endDateandTime || "";
   
      getLastIndexofEndDateTime = getLastIndexofEndDateTime || "";
    };
   
 
    //To calculate Downtime HRS,get the lastinderx of repairtracker end date time and workorder date time.
    let downTimeHrs = "0 Mins";
 
    // Convert to Date objects
    const workorderDate = new Date(workorderDateTime);
    const getEndDateTime = new Date(getLastIndexofEndDateTime);
    const getStartDateTime = new Date(getFirstIndexofStartDateTime);
     
    if (!isNaN(workorderDate.getTime()) && !isNaN(getEndDateTime.getTime() && !isNaN(getStartDateTime.getTime()))) {  
      // Calculate duration only if both dates are valid
        const scheduleDifference = Math.abs(getEndDateTime - getStartDateTime);
        const scheduletotalMinutes = Math.floor(scheduleDifference / (1000 * 60)); // Convert milliseconds to minutes
   
        downTimeHrs = `${scheduletotalMinutes} Mins`;
    };
 

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }
        // Format the date as 'dd/MM/yyyy HH:mm:ss'
        const formattedDate = format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss');
        return formattedDate;
    };

    const details = [
        { label: 'Scheduled Corrective No', value: basicDetails?.schcorrectiveno || "" },
        { label: 'WorkOrder Date & Time', value: formatDate(basicDetails?.workorderDateandTime) || "" },
        { label: 'Request details', value: basicDetails?.requestDetails || "" },
        { label: 'Respond Start Date & Time', value: formatDate(basicDetails?.assessments?.respondedStartDateandTime) || "" },
        { label: 'Respond End Date & Time', value: formatDate(basicDetails?.assessments?.respondedEndDateandTime) || "" },
        { label: 'Repair Duration', value: downTimeHrs || "" },
        { label: 'Spare Part Cost', value: basicDetails?.completionInfo?.costInfo?.totalSparePartCost || 0 },
        { label: 'Total WorkOrder Cost', value: basicDetails?.completionInfo?.costInfo?.totalWorkorderCost || 0 },
        { label: 'Task Code', value: basicDetails?.assessments?.taskCode?.label || "" },
        { label: 'Task Description', value: basicDetails?.assessments?.taskDescription || "" },
        {label:'Authorized By',value: completionInfo?.Authorizedby ? completionInfo?.Authorizedby || "" : basicDetails?.Authorizedby || "" }
       
    ];
    console.log(basicDetails,"basicdetails");
    

    const columns_Field = [
        ...(setOutsourceDetails
            ? [
                {
                    field: 'vendorCode',
                    headerName: 'Vendor Code',
                    flex: 1,
                    minWidth: isSmallScreen ? 80 : 120,
                    valueGetter: (params) => params?.data ? (getVendorCode || "") : ""                
                },
                {
                    field: 'vendorName',
                    headerName: 'Vendor Name',
                    flex: 1,
                    minWidth: isSmallScreen ? 80 : 120,
                    valueGetter: (params) => params?.data ? (getVendorName || "") : "",
                }
              ]
            : [
                {
                    field: 'respondedBy',
                    headerName: 'Employee Code',
                    flex: 1,
                    minWidth: isSmallScreen ? 80 : 120,
                    valueGetter: (params) => params?.data?.employeename ? params?.data?.employeename?.employeeCode || params?.data?.employeename?.employeecode : '',
                },
                {
                    field: 'respondedBy',
                    headerName: 'Employee Name',
                    flex: 1,
                    minWidth: isSmallScreen ? 80 : 120,
                    valueGetter: (params) => params?.data?.employeename ? params?.data.employeename?.employeename : '',
                },
            ]),
        {
            field: 'repairDuration',
            headerName: 'Response Hours',
            flex: 1,
            minWidth: isSmallScreen ? 80 : 120,
        }
    ];

    const handleConfirmAuthorize = async (event) => {
        event.preventDefault();
        setOpenAlertDialog(false);
        const checkFieldName = serviceType === "fem" ? "Fem" : "Bem";

        
                const APIPayload = {
                    rootcause: completionInfo?.rootCause || "",
                    completedbyempid: completionInfo?.completionBy?.id || "",
                    startdate: completionInfo?.startDateandTime || "",
                    enddate: completionInfo?.endDateandTime || "",
                    acceptedbyid: completionInfo?.respondedBy?.id || "",
                    isassetreqnotavail: completionInfo?.isassetreqnotavail || false,
                    actiontaken: completionInfo?.actionTaken || "",
                    downtimehours: completionInfo?.downTimeHours || "",
                    sparepartscost: totalSparePartCost || "",
                    ppmcost: costInfo?.ppmCostByPurchaseOrder || "",
                    ppmcostpurorderno: costInfo?.poNumberByPurchaseOrder || "",
                    contractppmcost: costInfo?.ppmCostByContract || "",
                    contractrefno: costInfo?.contractReferenceNumber || "",
                    breakdowncost: costInfo?.breakDownCost || "",
                    breakdowncostpurorderno: costInfo?.poNumber || "",
                    totalwocost: costInfo?.totalWorkorderCost || "",
                    id: completionInfo?.id || "",
                    [`${checkFieldName}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                    timestamp: completionInfo?.timeStamp || "",
                    authorizedbyid:userID || "",
                    authorizeddate:dayjs().format("YYYY-MM-DDTHH:mm:ss")
                };
        
                const updateCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionInfo?.id, APIPayload)
                dispatch({ type: "CREATE_COMPLETIONINFO", payload: { ...completionInfo, id: updateCompletionInfo?.id, timeStamp: updateCompletionInfo?.timestamp || "",Authorizedby:authorizeBy } });

        await ScmRepositry.workorderStatusValue(serviceType, basicDetails?.id, statusList?.closed?.id, processingPercentageValue?.summaryAndAuthorization);
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.closed?.label, percentage: processingPercentageValue?.summaryAndAuthorization }));
        dispatch(checkFormSubmitForVendor("CHECK_FORMSUBMITTED_WORKORDER", true));
    };

    const handleConfirmSave = async (event) => {
        event.preventDefault();
        setOpenSaveDialog(false);
        setAuthorizeTick(1);
        setEnableSave(true);
        dispatch(checkFormSubmitForVendor("CHECK_FORMSUBMITTED_WORKORDER", false));
    };

    const handleCloseDialog = () => {
        setOpenAlertDialog(false)
    };

    const handleCloseSaveDialog = () => {
        setOpenSaveDialog(false);
    };

    const handleopenAuthorizeDialog = () => {
        setOpenAlertDialog(true)
    };

    const handleopenSaveDialog = () => {
        setOpenSaveDialog(true);
    };

    const fetchImagesForFiles = async (files) => {
        try {
            const updatedFiles = await Promise.all(
                files.map(async (file) => {
                    const imageurl = `${MasterGraph}/api/FileUpload/DownloadFile/${file.filename}`;
                    const response = await fetch(imageurl, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                    if (response.ok) {
                        const blob = await response.blob();
                        const reader = new FileReader();

                        return new Promise((resolve) => {
                            reader.onloadend = () => {
                                resolve({ ...file, url: reader.result });
                            };
                            reader.readAsDataURL(blob);
                        });
                    } else {
                        console.error('Failed to fetch image');
                        return file;
                    }
                })
            );
            const beforImages = updatedFiles?.filter(file => file?.attachmentType === 1);
            const afterImages = updatedFiles?.filter(file => file?.attachmentType === 2);
            setBeforeImageURL(beforImages);
            setAfterImageURL(afterImages);
        } catch (error) {
            console.error('Error fetching images:', error);
        }
    };


    const fetchFiles = async () => {

        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkFieldName = serviceType === "fem" ? "fem" : "bem"
        const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
        let schWorkorderAttachments = [];

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        try {
            const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetschcorrectiveattachmentList/${basicDetails?.id},1,1000`, config);
            const fetchedFiles = response.data;
            
            const gridRows = fetchedFiles.map((file, index) => ({
                id: file?.id,
                filename: file?.filename,
                filepath: file?.filepath,
                filesize: file?.filesize,
                documenttitle: file?.documenttitle,
                documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
                attachmentType: file?.[`${checkFieldName}woattachmenttypeId`],
            }));

            if(basicDetails?.referenceWorkOrderNo?.id){
                schWorkorderAttachments = await axios.get(`${checkGraph}/api/${checkFemorBem}unscheduledworkorder/GetscheduledAttachmentsList/${basicDetails?.workorderId},1,1000`, config);
            };

            const schAttachments = schWorkorderAttachments?.data?.map((file) => {
                return {
                    id: file?.id,
                    filename: file?.filename,
                    filepath: file?.filepath,
                    filesize: file?.filesize,
                    documenttitle: file?.documenttitle,
                    documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
                    attachmentType: file?.[`${checkFieldName}woattachmenttypeId`],
                };
            });

            let mainRows = [...(gridRows || []), ...(schAttachments || [])];


            if (response?.data?.length > 0 || schAttachments?.length > 0) {
                fetchImagesForFiles(mainRows);
            }
        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };



    const handleImageClick = (image) => {
        setPopupImage(image);  // Show the pop-up with the current image
    };

    const handleModalClose = () => {
        setPopupImage(null);
    };


    useEffect(() => {
        fetchFiles();
    }, []);


    return (
        <>
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
                requiredButton={findHeaderContent?.requiredButton}
                statusType={"completed"}
            />
            <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                <form style={{ position: "relative" }} onSubmit={handleopenAuthorizeDialog}>
                    <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                        <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.workOrderNo || ""}</Typography>
                    </Stack>
                    <>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                backgroundColor: '#f5f5f5',
                                border: '1px solid #EFEEF0',
                                borderRadius: '20px',
                                padding: '16px',
                            }}
                        >
                            <Typography variant="h5" gutterBottom>
                                Summary Details
                            </Typography>
                            <Box mb={3} />
                            <Grid container spacing={2}>
                                {details.map((detail, index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                                        <Box>
                                            <Typography variant="body2" sx={{ color: 'grey' }}>
                                                {detail.label}
                                            </Typography>
                                            <Typography variant="body1" fontWeight="bold">
                                                {detail.value}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Paper>
                        <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                            <CustomAgGrid
                                refSet={gridAPI}
                                rows={repairTrackerRows}
                                columns={columns_Field}
                                setGridApi={setGridApi}
                            />
                        </Box>

                        <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                            <Grid container spacing={2}>
                                {(beforeImageURL?.length > 0 || afterImageURL?.length > 0) && (
                                    <>
                                        {/* Before Images */}
                                        <Grid item xs={6}>
                                            {beforeImageURL?.length > 0 ? (
                                                <>
                                                    <h2>Before Work Image</h2>
                                                    <ImageList cols={1} gap={8} style={{ maxWidth: "100%" }}>
                                                        {beforeImageURL?.map((image, index) => (
                                                            <ImageListItem key={index} style={{ marginTop: "5px", position: "relative", overflowY: "hidden", }} >
                                                                <div
                                                                    style={{
                                                                        width: "550px", // Increased fixed width for the box
                                                                        height: "350px", // Increased fixed height for the box
                                                                        borderRadius: "12px",
                                                                        border: "2px solid rgba(0, 0, 0, 0.1)",
                                                                        padding: "5px",
                                                                        boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                                                        margin: "0 auto",
                                                                        transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                                                        display: 'flex', // Use flexbox for centering the image
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        overflowY: "hidden",

                                                                    }}
                                                                >
                                                                    <img
                                                                        src={image?.url}
                                                                        alt={image?.documenttitle || "image"}
                                                                        style={{
                                                                            maxWidth: "100%", // Allow image to take up available width
                                                                            maxHeight: "100%", // Allow image to take up available height
                                                                            objectFit: "contain", // Maintain aspect ratio without cropping
                                                                            transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                                                        }}
                                                                        onClick={() => handleImageClick(image)}
                                                                    />
                                                                </div>
                                                                <ImageListItemBar title={image.documenttitle} style={{
                                                                    width: "550px", // Increased fixed width for the box
                                                                    height: "40px"
                                                                }} />
                                                            </ImageListItem>
                                                        ))}
                                                    </ImageList>
                                                </>
                                            ) : afterImageURL?.length > 0 ? (
                                                <>
                                                    <h2>After Work Image</h2>
                                                    <ImageList cols={1} gap={8} style={{ maxWidth: "100%" }}>
                                                        {afterImageURL?.map((image, index) => (
                                                            <ImageListItem key={index} style={{ marginTop: "5px", position: "relative", overflowY: "hidden", }}>
                                                                <div
                                                                    style={{
                                                                        width: "550px", // Increased fixed width for the box
                                                                        height: "350px", // Increased fixed height for the box
                                                                        borderRadius: "12px",
                                                                        border: "2px solid rgba(0, 0, 0, 0.1)",
                                                                        padding: "5px",
                                                                        boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                                                        margin: "0 auto",
                                                                        transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                                                        display: 'flex', // Use flexbox for centering the image
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        overflowY: "hidden",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={image?.url}
                                                                        alt={image?.documenttitle || "image"}
                                                                        style={{
                                                                            maxWidth: "100%", // Allow image to take up available width
                                                                            maxHeight: "100%", // Allow image to take up available height
                                                                            objectFit: "contain", // Maintain aspect ratio without cropping
                                                                            transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                                                        }}
                                                                        onClick={() => handleImageClick(image)}
                                                                    />
                                                                </div>
                                                                <ImageListItemBar title={image.documenttitle} style={{
                                                                    width: "550px", // Increased fixed width for the box
                                                                    height: "40px"
                                                                }} />
                                                            </ImageListItem>
                                                        ))}
                                                    </ImageList>
                                                </>
                                            ) : null}
                                        </Grid>

                                        {/* After Images */}
                                        {beforeImageURL?.length > 0 && afterImageURL?.length > 0 && (
                                            <Grid item xs={6}>
                                                <h2>After Work Image</h2>
                                                <ImageList cols={1} gap={8} style={{ maxWidth: "100%" }}>
                                                    {afterImageURL?.map((image, index) => (
                                                        <ImageListItem key={index} style={{ marginTop: "5px", position: "relative", overflowY: "hidden", }}>
                                                            {/* Fixed-size container for the image */}
                                                            <div
                                                                style={{
                                                                    width: "550px", // Increased fixed width for the box
                                                                    height: "350px", // Increased fixed height for the box

                                                                    borderRadius: "12px",
                                                                    border: "2px solid rgba(0, 0, 0, 0.1)",
                                                                    padding: "5px",
                                                                    boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                                                    margin: "0 auto",
                                                                    transition: "transform 0.3s ease, box-shadow 0.10s ease",
                                                                    display: 'flex', // Use flexbox for centering the image
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',

                                                                }}
                                                            >
                                                                <img
                                                                    src={image?.url}
                                                                    alt={image?.documenttitle || "image"}
                                                                    style={{
                                                                        maxWidth: "100%", // Allow image to take up available width
                                                                        maxHeight: "100%", // Allow image to take up available height
                                                                        objectFit: "contain", // Maintain aspect ratio without cropping
                                                                        transition: "transform 0.3s ease, box-shadow 0.10s ease",

                                                                    }}
                                                                    onClick={() => handleImageClick(image)}
                                                                />
                                                            </div>
                                                            <ImageListItemBar title={image.documenttitle} style={{
                                                                width: "550px", // Increased fixed width for the box
                                                                height: "40px"
                                                            }} />
                                                        </ImageListItem>
                                                    ))}
                                                </ImageList>

                                            </Grid>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </Box>

                        {popupImage && (
                            <>
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        zIndex: 10,
                                    }}
                                    onClick={handleModalClose}
                                />

                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 20,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {/* Image container */}
                                    <div
                                        style={{
                                            position: 'relative',
                                            maxWidth: '110%',
                                            maxHeight: '110%',
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {/* Cancel/Close Icon */}
                                        <button
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '10px',
                                                background: 'none',
                                                border: 'none',
                                                fontSize: '24px',
                                                // color: '#fff',
                                                cursor: 'pointer',
                                                zIndex: 10,
                                            }}
                                            onClick={handleModalClose}
                                        >
                                            &times; {/* This is the 'X' symbol for the close button */}
                                        </button>

                                        <img
                                            src={popupImage?.url}
                                            alt={popupImage?.documenttitle || 'image'}
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                borderRadius: '12px',
                                                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                                            }}
                                            onClick={(e) => e.stopPropagation()} // Prevents the modal from closing when clicking on the image
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                    </>
                    <Box>
                        <ScmBottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} authorizeButton={access?.canAuthorize} continueButton={access?.canAuthorize} authorizeClick={handleopenAuthorizeDialog} enableAuthorizeButton={ !enableSave || checkFormSubmitted} saveButton={true} saveButtonName={"Save"} saveClick={handleopenSaveDialog} disableSave={enableSave || viewmode || mappedStatus === 6 || mappedStatus === 5} />
                    </Box>
                </form>

                <CustomAlert
                    open={openSaveDialog}
                    onClose={handleCloseSaveDialog}
                    onConfirm={handleConfirmSave}
                    content={`${basicDetails?.schcorrectiveno || ""} has been Submitted Successfully.`}
                    confirmBtn='OK'
                />

                <CustomAlert
                    open={openAlertDialog}
                    onClose={handleCloseDialog}
                    onConfirm={handleConfirmAuthorize}
                    content={`${basicDetails?.schcorrectiveno || ""} has been Authorized Successfully.`}
                    confirmBtn='OK'
                />
            </Box>

        </>
    );
};

export default ScmSummaryAuthorization;
